import { takeLatest, put } from "redux-saga/effects";
import { ApiCall } from "../api";
import {
  USR_LOGIN_START,
  USR_LOGIN_COMPLETE,
  USR_LOGOUT_START,
  USR_LOGOUT_COMPLETE,
  USR_SETUSER_START,
  USR_CARGANDO_COMPLETE,
  USR_ERROR_COMPLETE,
} from "../../const/actionTypes";

export function* Login({ payload }) {
  try {
    yield put({ type: USR_ERROR_COMPLETE, payload: "" });
    yield put({ type: USR_CARGANDO_COMPLETE, payload: true });

    const data = JSON.stringify({
      userName: payload.userName,
      password: payload.password,
      auth: true,
    });
    const json = yield ApiCall("/api/Login", "POST", data);
    if (json !== null && json.id_usuario > 0) {
      localStorage.setItem("novedades", json.user);
      yield put({ type: USR_LOGIN_COMPLETE, payload: json });
    } else {
      yield put({
        type: USR_ERROR_COMPLETE,
        payload: "Usuario y/o contraseña incorrectos.",
      });
    }
  } catch (error) {
  } finally {
    yield put({ type: USR_CARGANDO_COMPLETE, payload: false });
  }
}
export function* SetUser({ payload }) {
  try {
    yield put({ type: USR_CARGANDO_COMPLETE, payload: true });
    const cookie = localStorage.getItem("novedades");
    const data = JSON.stringify({
      userName: cookie,
      password: "",
      auth: false,
    });
    const json = yield ApiCall("/api/Login", "POST", data);
    if (json !== null && json.id_usuario > 0) {
      yield put({ type: USR_LOGIN_COMPLETE, payload: json });
    }
  } catch (error) {
  } finally {
    yield put({ type: USR_CARGANDO_COMPLETE, payload: false });
  }
}
export function* Logout({ payload }) {
  try {
    localStorage.setItem("novedades", "");
    yield put({ type: USR_LOGOUT_COMPLETE });
  } catch (error) {}
}

export default function* configuration() {
  yield takeLatest(USR_SETUSER_START, SetUser);
  yield takeLatest(USR_LOGIN_START, Login);
  yield takeLatest(USR_LOGOUT_START, Logout);
}
